import React, { useEffect } from 'react';
import { useActiveInfoKey, useActiveOriginIndex, useFramework } from '@/framework';
import {
    BaseLayerViewType,
    IBaseCustomData,
    IBaseMoveData,
    IBaseResizeData,
    IBaseRotateData,
    IBaseScaleData,
} from '@/version-types';
import { RealEdit } from '..';
import './index.less';

/**
 * 渲染编辑图层
 */
export const RoomOperate: React.FC = React.memo(() => {
    const framework = useFramework();
    const activeOriginIndex = useActiveOriginIndex();
    const realEdit = framework.getInstance(RealEdit);
    const activeInfoKey = useActiveInfoKey();

    /** 实例销毁 */
    useEffect(() => {
        return () => {
            realEdit.room.dispose();
        };
    }, []);

    /** 渲染用户选中图层 */
    useEffect(() => {
        realEdit.room.renderUserPick();
    }, [activeOriginIndex]);

    /** 设置选中图层 */
    useEffect(() => {
        const info = framework.operate.getActiveInfo();
        if (info) {
            realEdit.pickLayer.send(info.info.id, info.info.pickId);
        } else {
            realEdit.pickLayer.send();
        }
    }, [activeInfoKey]);

    /** 监听基础操作 */
    useEffect(() => {
        const baseOperateOldLayerInfo = {
            [BaseLayerViewType.MOVE]: null,
            [BaseLayerViewType.ROTATE]: null,
            [BaseLayerViewType.SCALE]: null,
            [BaseLayerViewType.RESIZE]: null,
        };
        const beforeHandler = framework.events.onBeforeBaseOperate((layer, type) => {
            baseOperateOldLayerInfo[type] = layer;
        });
        const handler = framework.events.onBaseOperate((_, type, args, data) => {
            if (!data) return;
            // console.log('ot 处理基础操作', type, args, data);

            switch (type) {
                case BaseLayerViewType.MOVE:
                    realEdit.moveOperate.send(args, data as IBaseMoveData, baseOperateOldLayerInfo[type]);
                    break;
                case BaseLayerViewType.ROTATE:
                    realEdit.rotateOperate.send(args, data as IBaseRotateData, baseOperateOldLayerInfo[type]);
                    break;
                case BaseLayerViewType.SCALE:
                    realEdit.scaleOperate.send(args, data as IBaseScaleData, baseOperateOldLayerInfo[type]);
                    break;
                case BaseLayerViewType.RESIZE:
                    realEdit.resizeOperate.send(args, data as IBaseResizeData, baseOperateOldLayerInfo[type]);
                    break;
                case BaseLayerViewType.CUSTOM:
                    realEdit.customOperate.send(args, data as IBaseCustomData);
                    break;
            }
            if (args.isEnd) {
                baseOperateOldLayerInfo[type] = null;
            }
        });
        return () => {
            framework.events.off(handler);
            framework.events.off(beforeHandler);
        };
    }, []);

    return null;
});
